import { render, staticRenderFns } from "./player-update-teams.vue?vue&type=template&id=c922b2c2&scoped=true&"
import script from "./player-update-teams.vue?vue&type=script&lang=js&"
export * from "./player-update-teams.vue?vue&type=script&lang=js&"
import style0 from "./player-update-teams.vue?vue&type=style&index=0&id=c922b2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c922b2c2",
  null
  
)

export default component.exports